import { render, staticRenderFns } from "./UserMoreDropdown.vue?vue&type=template&id=534eab78&scoped=true"
import script from "./UserMoreDropdown.vue?vue&type=script&lang=js"
export * from "./UserMoreDropdown.vue?vue&type=script&lang=js"
import style0 from "./UserMoreDropdown.vue?vue&type=style&index=0&id=534eab78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534eab78",
  null
  
)

export default component.exports